window.r9 = window.r9 || {};
// #################################################################################################### getStoreFrontToken()
window.r9.getStoreFrontToken = function() {
	return document.querySelector('meta[name="storefront-token"]')?.content || '';
}
// #################################################################################################### fetchFromStoreFront()
window.r9.fetchFromStoreFront = async function(query = '', variables = {}, method = 'POST', payload = {}, headers = {"Content-Type": "application/json"}) {
	try {
		const token = r9.getStoreFrontToken();
		headers['X-Shopify-Storefront-Access-Token'] = token;
		const res = await fetch('/api/2025-04/graphql.json', {method: method, headers: headers,
			body:JSON.stringify({
				query: query,
				variables: variables
			})
		});
		console.log('res', res);
		const json = await res.json();
		return json;
	}
	catch(err){
		console.error('An error occured during the fetch :', err);
	}
}
// #################################################################################################### Managing app proxy calls
window.r9.fetchAppProxy = async function(url = 'https://www.some-website.com/apps/path', method = 'GET', payload = {}, headers = {"Content-Type": "application/json"}) {
	try {
		if(!payload.hasOwnProperty('language')) payload.language = Shopify.locale;
		let r = await fetch(url, {
			method: method,
			headers: headers,
			body: JSON.stringify(payload)
		});
		response = await r.json();
	}
	catch(error) {
		console.error(error);
		response.message = error.message;
	}
	return response;
}
// #################################################################################################### getFormFields(event = null)
window.r9.getFormFields = function(event = null) {
	if(event === null || event instanceof SubmitEvent === false) {
		console.error("event must be a SubmitEvent");
		return null;
	}
	const formData = new FormData(event.target);
	const data = Object.fromEntries(Array.from(formData.entries(), ([k, v]) => [k, v.trim()]));
	return data;
}
// #################################################################################################### addSignatureToPayload(payload = {})
window.r9.addSignatureToPayload = function(payload = {}) {
	if(typeof payload !== 'object' || payload === null || Array.isArray(payload)) {
		console.error("payload must be a object {}");
		return null;
	}
	payload.csrf = document.querySelector('meta[name="api-csrf"]')?.content || '';
	payload.signature = document.querySelector('meta[name="api-signature"]')?.content || '';
	if(payload.csrf == '' || payload.signature == '') {
		console.error("CSRF and SIGNATURE can not be empty");
	}
	return payload;
}
// #################################################################################################### Managing form response
window.r9.handleResponse = function(response = null) {
	//console.log(response);
	if(response === null || typeof response.success !== 'boolean') {
		console.error("response.success must be a boolean");
		response.success = false;
	}
	if(response === null || typeof response.message !== 'string') {
		console.error("response.message must be a string");
		response.message = "A random error occured";
	}
	if(response.success === false) console.error(response.message);
	return response;
}
// #################################################################################################### Managing form response
window.r9.handleFormResponse = function(formId = '', response = null) {
	if(document.querySelector(`${formId} .form-response`) === null ) console.error("formId must be a valid selector and must have a .form-response child");
	response = r9.handleResponse(response);
	let formResponse = document.querySelector(`${formId} .form-response`);
	let formMessageSuccess = document.querySelector(`${formId}`).dataset.messageSuccess;
	let formMessageFailure = document.querySelector(`${formId}`).dataset.messageFailure;
	let cssClass = (response.success) ? 'success' : 'error';
	let formMessage = (response.success) ? formMessageSuccess : formMessageFailure;
	formResponse.classList.remove('success');
	formResponse.classList.remove('error');
	formResponse.classList.add(cssClass);
	formResponse.innerHTML = `<p>${formMessage}</p>`;
}
// #################################################################################################### r9-rich-text-h1-h2-text
document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.r9-rich-text-h1-h2-text').forEach(function (container) {
		var limit = parseInt(container.dataset.showMoreCount, 10);
		var isEnabled = container.dataset.showMoreEnabled === 'true';
		var ctaLabelMore = container.dataset.showMoreCtaMore || 'More';
		var ctaLabelLess = container.dataset.showMoreCtaLess || 'Less';
		if (!isEnabled || !limit) return;
		var textWrapper = container.querySelector('.metafield-multi_line_text_field');
		if (!textWrapper) return;
		var fullText = textWrapper.textContent.trim();
		if (fullText.length <= limit) return;
		var visibleText = fullText.slice(0, limit);
		var hiddenText = fullText.slice(limit);
		textWrapper.innerHTML =
		visibleText +
		'<span class="dots">...</span>' +
		'<span class="more-text" style="display: none;">' + hiddenText + '</span>';
		var button = document.createElement('span');
		button.className = 'btn-show-more r9-rich-text-h1-h2-text-show-more-btn';
		button.textContent = ctaLabelMore;
		button.addEventListener('click', function () {
			var isExpanded = textWrapper.classList.toggle('expanded');
			textWrapper.querySelector('.more-text').style.display = isExpanded ? 'inline' : 'none';
			textWrapper.querySelector('.dots').style.display = isExpanded ? 'none' : 'inline';
			button.textContent = isExpanded ? ctaLabelLess : ctaLabelMore;
		});
		textWrapper.insertAdjacentElement('afterend', button);
	});
});
// #################################################################################################### r9-content-tabs
document.addEventListener('DOMContentLoaded', function () {
  const tabSections = document.querySelectorAll('.r9-content-tabs');
  tabSections.forEach(section => {
    const buttons = section.querySelectorAll('.r9-content-tabs__nav-button');
    const contents = section.querySelectorAll('.r9-content-tabs__content');
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-tab');
        // Remove active class from all
        buttons.forEach(b => b.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));
        // Activate clicked
        button.classList.add('active');
        const targetContent = section.querySelector(`#${targetId}`);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  });
});
// #################################################################################################### r9-swatch-color-sorting
document.addEventListener('DOMContentLoaded', function () {
	const swatchColorsList = document.querySelector('drawer-component [id="drawer-filter.p.m.custom.color_main"] .accordion-details__content ul.grid');
	if(swatchColorsList) {
		const items = Array.from(swatchColorsList.querySelectorAll('li'));
		items.sort((a, b) => {
			const valA = a.querySelector('.r9-swatch-color')?.getAttribute('title') || '';
			const valB = b.querySelector('.r9-swatch-color')?.getAttribute('title') || '';
			return valA.localeCompare(valB, 'fr', { sensitivity: 'base' });
		});
		items.forEach(li => swatchColorsList.appendChild(li));
	}
});
// #################################################################################################### xxx
// #################################################################################################### xxx
// #################################################################################################### xxx
